(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atlas-environmental-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-atlas-environment-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closeButton = event.target.closest('[data-atlas-environment-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const dialog = event.target.closest('[data-atlas-environment-dialog]');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["professional-portal"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'collinson-professional-access';
    const root = document.getElementById('ProfessionalPortal');
    if (!root) return;

    const modal = root.querySelector('[data-professional-modal]');
    const form = root.querySelector('#ProfessionalAccessForm');
    const firstField = root.querySelector('#ProfessionalName');
    let lastTrigger = null;

    try {
      localStorage.removeItem(storageKey);
    } catch (error) {
      document.documentElement.classList.remove('professional-mode');
    }

    const isActive = () => document.documentElement.classList.contains('professional-mode');

    const openModal = (trigger) => {
      lastTrigger = trigger || document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      window.setTimeout(() => firstField?.focus(), 0);
    };

    const closeModal = () => {
      modal.hidden = true;
      document.body.style.overflow = '';
      lastTrigger?.focus();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-professional-open]');
      if (trigger) {
        event.preventDefault();
        if (trigger.closest('#MobileNav')) {
          document.querySelector('.mobile-nav-trigger')?.click();
        }
        openModal(trigger);
        return;
      }

      if (event.target.closest('[data-professional-close]')) {
        closeModal();
      }

      if (event.target.closest('[data-professional-exit]')) {
        try {
          sessionStorage.removeItem(storageKey);
          localStorage.removeItem(storageKey);
        } catch (error) {
          document.documentElement.classList.remove('professional-mode');
        }
        document.documentElement.classList.remove('professional-mode');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    form?.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      try {
        sessionStorage.setItem(storageKey, 'confirmed');
        document.documentElement.classList.add('professional-mode');
      } catch (error) {
        document.documentElement.classList.remove('professional-mode');
      }
    });

    document.addEventListener(
      'submit',
      (event) => {
        if (!isActive()) return;
        const submitter = event.submitter || document.activeElement;
        if (!submitter || submitter.getAttribute('name') !== 'checkout') return;

        const discountCodes = window.atob(root.dataset.discounts);
        const cartRoute = root.dataset.cartRoute || '/cart';
        event.target.setAttribute('action', `${cartRoute}?discount=${encodeURIComponent(discountCodes)}`);

        let discountInput = event.target.querySelector('input[name="discount"]');
        if (!discountInput) {
          discountInput = document.createElement('input');
          discountInput.type = 'hidden';
          discountInput.name = 'discount';
          event.target.appendChild(discountInput);
        }
        discountInput.value = discountCodes;
      },
      true
    );

    const refreshDynamicPrice = (retailNode) => {
      const priceSet = retailNode.closest('[data-professional-price]');
      const memberValue = priceSet?.querySelector('.professional-price-value');
      if (!priceSet || !memberValue) return;

      const factor = Number(priceSet.dataset.professionalFactor || 100) / 120;
      const text = retailNode.textContent.trim();
      const numericText = text.replace(/[^\d,.-]/g, '').replace(/,/g, '');
      const numericValue = Number.parseFloat(numericText);
      if (!Number.isFinite(numericValue)) return;

      const locale = document.documentElement.lang || 'en-GB';
      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: root.dataset.currency || 'GBP'
      }).format(numericValue * factor);
      memberValue.textContent = formatted;
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const retailNode =
          mutation.target.nodeType === Node.TEXT_NODE
            ? mutation.target.parentElement?.closest('.professional-price-retail')
            : mutation.target.closest?.('.professional-price-retail');
        if (retailNode) refreshDynamicPrice(retailNode);
      });
    });

    document.querySelectorAll('[data-professional-dynamic]').forEach((priceSet) => {
      const retailNode = priceSet.querySelector('.professional-price-retail');
      if (retailNode) observer.observe(retailNode, { childList: true, characterData: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
